import { Button, Container, Grid, Paper } from "@mui/material";
import api from "../../api/axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function ConfirmationAccount() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("confirmation_token");
  const navigate = useNavigate();

  const handleConfirmAccount = async () => {
    try {
      const response = await api.get(
        `api/v1/confirmation?confirmation_token=${token}`
      );
      toast.success(response.data.message);
      navigate("/", { replace: true });
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
      } else {
        let errors = err.response.data.errors;

        

        if (Array.isArray(errors)) {
          errors = errors.join(", ");
        }
        toast.error(errors);
      }
    }
  };
  return (
    <Container maxWidth="sm">
      <h1 align="center">Confirmar cuenta</h1>
      <Grid
        container
        spacing={2}
        direction="column"
        justifyContent="center"
        style={{ minHeigt: "100vh" }}
      >
        <Paper elevation={2} sx={{ padding: 5 }}>
          <Button
            variant="contained"
            fullWidth
            type="submit"
            onClick={handleConfirmAccount}
          >
            Confirmar
          </Button>
        </Paper>
      </Grid>
    </Container>
  );
}
